define('views/modules/member/select/member-select-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/user',
    // views
    'views/parts/media-info-box',
], function(
    // Libs
    _, Backbone, Mustache, U,
    User,
    // views
    VMediaInfoBox
) {

    var VMemberListItem = Backbone.View.extend({
        className: 'member-list-item',

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                infobox: new VMediaInfoBox({
                    title: 'name',
                    subtitle: 'email',
                    tinyinfo: 'groupName',
                    photo: "thumbnail",
                    model: this.model,
                    context: this,
                    onClick: this.onClick,
                    menu: false,
                }),
            };

            this.listenTo(this.model, {
                'select:all': this.onSelectAll,
                'deselect:all': this.onDeselectAll
            });
        },

        render: function() {
            this.assign(this.view.infobox, this.$el);
            return this;
        },

        setActive: function(val) {
            this.$el.toggleClass('active', val);
            return this;
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },


        ////////////
        // events //
        ////////////

        onClick: function(e) {
            this.setActive();
            this.model.trigger('member:click', this.model, this.isActive());
        },


    });

    return VMemberListItem;

});

